import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare var Stripe: any;

@Component({
  selector: "app-webflow-product-details",
  templateUrl: "./webflow-product-details.component.html",
  styleUrls: ["./webflow-product-details.component.scss"],
})
export class WebflowProductDetailsComponent {
  constructor(public http: HttpClient,public router: Router,public activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer) {}

  customerData = {
    assessmentType: "",
    assessmentMedium: "",
    assessmentLanguage: "",
    guide: "",
    email: "",
    teamName: "",
    organizationName: "FourSight",
    quantity: 1,
    sku: "",
    description: ""
  };
  card_save = "";
  captureBody;
  variant;
  details:any= {
    name:'FourSight for Teams',
    image_url:"https://s3.ca-central-1.amazonaws.com/assets.foursightonline.com/app/images/store/webflow.jpg",
    description: "<p>Ready to bring FourSight to your team? The FourSight Mindset Reveal is a fun, dynamic,team building workshop that helps team members think better together. It includes:</p><p><strong class='f-weight-bold'>Individual Assessment</strong></p><ul><li>FourSight Thinking Profile assessment (takes ~ 10 minutes to complete)</li><li>Individual & team reports.</li></ul><p><strong class='f-weight-bold'>Team Insights & Problem-solving Tools (1-year subscription).</strong></p><ul><li>Team Insights and collaboration advice</li><li>Tool Library (22 problem-solving tools)</li><li>Problem-solving guide (start with a challenge, end with a solution)</li></ul>",
    price_range: '63-120',
  }
  havingQueryParams:any;

  ngOnInit() {
    this.http
      .get(
        `${environment.assessment_admin}api/v1/public/products/foursight-thinking-profile-assessment`
      )
      .subscribe((data) => {
        console.log(data);
        this.variant = data["product"]["variants"];
      });
      this.activatedRoute.queryParams.subscribe(prm=> {
        if (prm.org) {
          this.havingQueryParams = prm;
          this.details.name = 'FourSight for ' + '<span class="title-case">' + prm.org + '</span>';
          this.customerData.assessmentMedium = "Online";
          this.customerData.assessmentLanguage = "0011-en-001-o-k"
          this.customerData.guide = "Pdf";
          this.customerData.organizationName = prm.org;
        }
        console.log(this.havingQueryParams);
      })
  }

  updatePrice(){
    if(this.customerData.assessmentType == '1011-on-001-o-i-webflow-assessment-with-teams') {
      this.details.price_range = 120 * this.customerData.quantity;
    } else if(this.customerData.assessmentType == '1011-on-001-o-i-webflow-assessment-only2') {
      this.details.price_range = 63 * this.customerData.quantity;
    }
    this.customerData.sku = this.customerData.assessmentType
  }

  get sanitizedContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.details.name);
  }

  createOrder() {
    console.log("language", this.customerData);
    // this.customerData.sku = this.customerData.assessmentLanguage;
    this.customerData.description = 'team_name:' + this.customerData.teamName + 'Teamorg_name:' + this.customerData.organizationName;
    let data = {
      sku: this.customerData.sku,
      description: this.customerData.description,
      quantity: this.customerData.quantity,
      email: this.customerData.email,
    }
    this.http
      .post(
        `${environment.profileURL}/api/v1/public/guest_orders`,
        data
      )
      .subscribe((data) => {
        console.log(data);
        let paymentBody = {
          id: data["guest_order"]["number"],
        };
        $(".add-card-modal").css("display", "block");
        this.http
          .post(
            `${environment.profileURL}/api/v1/public/guest_orders/create_payment`,
            paymentBody
          )
          .subscribe((py) => {
            console.warn("payment", py);
            this.captureBody = {
              id: data["guest_order"]["number"],
            };
            this.checkoutCard(data["guest_order"]["email"]);
          });
      });
  }

  public checkoutCard(first_name) {
    var stripe = Stripe(environment.stripe_api_key);
    $("#card_error").hide();
    // if(this.new_card){
    localStorage.setItem("last4", "");
    console.log(stripe);
    var elements = stripe.elements();
    var cardElement = elements.create("card");
    console.log(cardElement);
    var clientSecret = "";
    setTimeout(function () {
      cardElement.mount("#card-element");
    }, 0);
    var that = this;
    console.log(cardElement);
    // create card payment intent
    var cardButton = document.getElementById("card_button");
    cardButton.addEventListener("click", function (ev) {
      // $('#stripe_checkout').hide();
      // $('#stripe_card').show();
      // $('#card_button').show();
      stripe
        .createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            // name: 'Jenny Rosen',
            name: first_name,
          },
        })
        .then(function (result) {
          console.log("res1", result);
          localStorage.setItem(
            "new-card",
            JSON.stringify({
              brand: result?.paymentMethod?.card?.brand,
              last4: result?.paymentMethod?.card?.last4,
            })
          );
          that.card_save = result?.paymentMethod?.id;
          // that.modal1.close();  // close stripe popup
          // Handle result.error or result.paymentMethod
          if (result?.error) {
            console.log(result?.error);
            let error = document.getElementById("stripe_error");
            error.innerHTML = result["error"]["message"];
          } else {
            let data;
            $(".loader-container").css("display", "flex");
            $(".add-card-modal").css("display", "none");
            console.log(result.paymentMethod.id);
            that.captureBody["payment_method_id"] = result.paymentMethod.id;
            that.http
              .post(
                `${environment.profileURL}/api/v1/public/guest_orders/capture_payment`,
                that.captureBody
              )
              .subscribe(
                (data) => {
                  console.warn("capture", data);
                  $('.thanku-popup').css('display', 'block');
                },
                (error) => {
                  console.log("oops", error["error"]);
                  // payment requires more authentication
                  if (
                    error["error"]["status"] == "requires_action" ||
                    error["error"]["status"] == "requires_payment_method" ||
                    error["error"]["status"] == "requires_source_action" ||
                    error["error"]["status"] == "requires_confirmation"
                  ) {
                    // confirming payment
                    stripe
                      .confirmCardPayment(
                        error["error"]["payment_intent_secret"],
                        {
                          payment_method: error["error"]["payment_method_id"],
                        }
                      )
                      .then(function (result) {
                        console.warn("result", result);
                        if (result.error) { 
                          // Display error.message in your UI.
                          console.log(result);
                          if (result.error.message) {
                            $("#stripe_error").html(result.error.message);
                            $("#stripe_error").show();
                            setTimeout(function () {
                              this.toastr.options = {
                                closeButton: true,
                                timeOut: 10000,
                              };
                              this.toastr.error(result.error.message, "oops!");
                            }, 1000);
                          } else {
                            $("#stripe_error").html(
                              "Please try a different card or contact support in the chat window below."
                            );
                            $("#stripe_error").show();
                            setTimeout(function () {
                              this.toastr.options = {
                                closeButton: true,
                                timeOut: 10000,
                              };
                              this.toastr.error(
                                "Please try a different card or contact support in the chat window below.",
                                "Something went wrong!"
                              );
                            }, 1000);
                          }
                        } else if(result['paymentIntent']['status'] == "succeeded") {

                          that.http.post(`${environment.profileURL}/api/v1/public/guest_orders/capture_payment`,that.captureBody).subscribe((data) => {
                            console.warn('capture',data)
                            $('.thanku-popup').css('display', 'block');
                          })
                        }
                      });
                  } else {
                    if (error.status == 500) {
                      $("#stripe_error").html(
                        "Please try a different card or contact support in the chat window below."
                      );
                      $("#stripe_error").show();
                      setTimeout(function () {
                        this.toastr.options = {
                          closeButton: true,
                          timeOut: 10000,
                        };
                        this.toastr.error("Something went wrong!", "Sorry!");
                      }, 1000);
                    } else if (error.status == 422) {
                      setTimeout(function () {
                        this.toastr.options = {
                          closeButton: true,
                          timeOut: 10000,
                        };
                        if (!error.error.errors.base[0]) {
                          $("#stripe_error").html(error.error.errors);
                          $("#stripe_error").show();
                          this.toastr.error(error.error.errors, "oops!");
                        } else {
                          $("#stripe_error").html(error.error.errors.base[0]);
                          $("#stripe_error").show();
                          this.toastr.error(
                            error.error.errors.base[0],
                            "oops!"
                          );
                        }
                      }, 1000);
                    } else {
                      $("#stripe_error").html(
                        "Please try a different card or contact support in the chat window below."
                      );
                      $("#stripe_error").show();
                      setTimeout(function () {
                        this.toastr.options = {
                          closeButton: true,
                          timeOut: 10000,
                        };
                        this.toastr.error("Something went wrong!", "oops!");
                      }, 1000);
                    }
                  }
                }
              );
          }
        });
    });
    // }
  }
}
